<template>
    <div>
        <h1>Update User Information</h1>
        <div v-if="!isNameUpdate">
            <div class="card">
                <div class="card-header">Name</div>
                <div class="card-body">
                    <b-row>
                        <b-col cols="4"><span class="font-weight-bold">Last Name: </span>{{application.lastName}}</b-col>
                        <b-col cols="3"><span class="font-weight-bold">First Name: </span>{{application.firstName}}</b-col>
                        <b-col cols="3"><span class="font-weight-bold">Middle Name: </span>{{application.middleName}}</b-col>
<!--                        <b-col cols="2" rowspan="2">-->
<!--                            <b-button type="button" variant="secondary" role="button" class="mr-1" @click="toggleUpdate('n')">Update Name</b-button>-->
<!--                        </b-col>-->
                    </b-row>
                </div>
            </div>
        </div>
<!--        <div v-if="isNameUpdate">-->
<!--            <NameUpdate :application="application" @on-validate="mergeAndToggle"></NameUpdate>-->
<!--        </div>-->
        <div v-if="!isInfoUpdate">
            <div class="card">
                <div class="card-header">Contact Information</div>
                <div class="card-body">
                    <b-row>
                        <b-col cols="5"><span class="font-weight-bold">Phone Number: </span>{{application.preferredPhone}}</b-col>
                        <b-col cols="5"><span class="font-weight-bold">Email: </span>{{application.emailAddress}}</b-col>
                        <b-col cols="2" rowspan="2">
                            <b-button type="button" variant="secondary" role="button" class="mr-1" @click="toggleUpdate('c')">Update Email/Phone</b-button>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
        <div v-if="isInfoUpdate">
            <ContactUpdate :application="application" @on-validate="mergeAndToggle"></ContactUpdate>
        </div>
        <div v-if="!isAddressUpdate">
            <div class="card">
                <div class="card-header">Address</div>
                <div class="card-body">
                    <b-row>
                        <b-table hover small responsive show-empty class="sr-caption"
                                 id="addressTbl"
                                 :fields="application.international ? intlAddressFields : addressFields"
                                 :items="application.address"
                                 label-sort-asc=""
                                 label-sort-desc=""
                                 caption="Addresses table.  To sort the data in this table by a specific column,
                                    go to the appropriate column header cell and use enter to sort the data ascending.
                                    Use enter again to sort descending.">
                            <template v-slot:empty="scope">
                                <p>No addresses found.</p>
                            </template>
                            <template v-slot:cell(country)="data">
                                {{opts.countryOptions.find(c => c.value === data.item.country).text}}
                            </template>
                        </b-table>
                    </b-row>
                    <b-row>
                        <b-col>
                            <button class="btn btn-secondary" @click="toggleUpdate('a')">
                                Update Address(es)
                            </button>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
        <div v-if="isAddressUpdate">
            <AddressUpdate :application="application" @on-validate="mergeAndToggle"></AddressUpdate>
        </div>
        <div v-if="!isEmployerUpdate && application.subCategory === 'FULL'">
            <div class="card">
                <div class="card-header">Employer(s)</div>
                <div class="card-body">
                    <b-row>
                        <b-table hover small responsive show-empty class="sr-caption"
                                 id="employerTbl"
                                 :fields="employerFields"
                                 :items="application.employers"
                                 label-sort-asc=""
                                 label-sort-desc=""
                                 caption="Employer table.  To sort the data in this table by a specific column,
                                    go to the appropriate column header cell and use enter to sort the data ascending.
                                    Use enter again to sort descending.">
                            <template v-slot:empty="scope">
                                <p>No employers found.</p>
                            </template>
                        </b-table>
                    </b-row>
                    <b-row>
                        <b-col>
                            <button class="btn btn-secondary" @click="toggleUpdate('e')">
                                Update Employer(s)
                            </button>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
        <div v-if="isEmployerUpdate">
            <EmployerUpdate :application="application" :oldEmp="oldEmp" @on-validate="mergeAndToggle"></EmployerUpdate>
        </div>
    </div>
</template>
<script>
    // import NameUpdate from '@/components/info-update/NameUpdate.vue'
    import ContactUpdate from '@/components/info-update/ContactUpdate.vue'
    import AddressUpdate from '@/components/info-update/AddressUpdate.vue'
    import EmployerUpdate from '@/components/info-update/EmployerUpdate.vue'
    import axios from "axios"
    import axiosRetry from 'axios-retry'
    import { required, minLength, maxLength, email } from 'vuelidate/lib/validators'
    import { commonOptions } from '@/mixins/commonOptions.js'

    axiosRetry(axios, { retries: 3,
        retryDelay: axiosRetry.exponentialDelay  })

    export default {
        data() {
            return {
                application: {},
                oldEmp: [],
                addressFields:  [
                    {key: 'description', label: 'Address Type', sortable: true},
                    {key: "streetAddress", label: "Street Address", sortable: true},
                    {key: "city", label: "City", sortable: true},
                    {key: "state", label: "State", sortable: true},
                    {key: "postalCode", label: "ZIP", sortable: true},
                    {key: 'preferred', label: 'Preferred', sortable: true}
                ],
                intlAddressFields:  [
                    {key: 'description', label: 'Address Type', sortable: true},
                    {key: "streetAddress", label: "Street Address", sortable: true},
                    {key: "city", label: "City", sortable: true},
                    {key: "stateProv", label: "State/Province", sortable: true},
                    {key: "postalCode", label: "Postal Code", sortable: true},
                    {key: "country", label: "Country", sortable: true},
                    {key: 'preferred', label: 'Preferred', sortable: true}
                ],
                employerFields:  [
                    {key: "name", label: "Name", sortable: true},
                    {key: "streetAddress", label: "Street Address", sortable: true},
                    {key: "city", label: "City", sortable: true},
                    {key: "state", label: "State", sortable: true},
                    {key: "postalCode", label: "ZIP", sortable: true},
                    {key: 'phone', label: 'Phone', sortable: true},
                    {key: 'emailAddress', label: 'Email', sortable: true},
                    {key: 'startDate', label: 'Start Date', sortable: true},
                    {key: 'endDate', label: 'End Date', sortable: true}
                ],
                isAddressUpdate: false,
                isInfoUpdate: false,
                isNameUpdate: false,
                isEmployerUpdate: false,
            }
        },
        mixins: [
            commonOptions
        ],
        methods: {
            loading() {
                //adding settimeout as emit is not recognized from inside .then function
                setTimeout(() => {
                    this.loadApplication()
                }, 1000)
            },
            loadApplication() {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/latest`)
                    .then(response => {
                    this.application =  response.data
                    this.oldEmp = response.data.employers != null ? response.data.employers.map(e => e.endDate) : null
                    this.application.license.licenseType = response.data.license.licenseType.code
                    this.application.applyMethod = response.data.applyMethod ? response.data.applyMethod.code : null
                    this.application.mnSupervisor = null
                    this.application.prevMnSupervisor = null

                    if (!response.data.address || response.data.address.length === 0 ) {
                        this.application.address = [];
                    }
                     for(var i = 0; i < response.data.address.length; i++) {
                         this.application.address[i].description =
                             response.data.address[i]?.addressType?.description
                         this.application.address[i].addressType =
                             response.data.address[i]?.addressType?.code
                     }
                })
            },
            mergeAndToggle(section, model, isValid) {
                if (isValid) {
                    this.application = Object.assign({}, this.application, this.$data)
                    if(section === 'a') {
                        for(var i = 0; i < this.application.address.length; i++) {
                            this.application.address[i].description =
                                this.application.address[i].addressType === 'H' ? "Home" : "Employer"
                        }
                    }
                    this.toggleUpdate(section)
                }
            },
            toggleUpdate(section) {
                switch(section) {
                    case 'a':
                        this.isAddressUpdate = !this.isAddressUpdate
                        break
                    case 'e':
                        this.isEmployerUpdate = !this.isEmployerUpdate
                        break
                    case 'n':
                        this.isNameUpdate = !this.isNameUpdate
                        break
                    case 'c':
                        this.isInfoUpdate = !this.isInfoUpdate
                        break
                }
            }
        },
        created() {
            document.title = "Update User Information - Body Art"
            this.loadApplication()
        },
        components: {
            // NameUpdate,
            ContactUpdate,
            AddressUpdate,
            EmployerUpdate,
        },
    }
</script>